import axiosInstance from './axiosInstance'

export const getProjectExtraDetailById = (id) => {
  return axiosInstance.get(`/project-extra-details/${id}`)
}

export const getProjectExtraDetailByProjectId = (projectId) => {
  return axiosInstance.get(`/project-extra-details/?projectId=${projectId}`)
}

export const getProjectExtraDetailAuditTrails = (projectExtraDetailId) => {
  return axiosInstance.get(`/project-extra-details/${projectExtraDetailId}/audit-trails`)
}

// export const getProjectExtraDetails = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc') => {
//   return axiosInstance.get(`/project-extra-details?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}`)
// }

export const createProjectExtraDetail = (data) => {
  return axiosInstance.post('/project-extra-details', data)
}

export const upsertProjectExtraDetail = (id, data) => {
  return axiosInstance.put(`/project-extra-details/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteProjectExtraDetail = (id) => {
  return axiosInstance.delete(`/project-extra-details/${id}`)
}
